import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

class ControlOption extends Component {

  render() {
    const {
      inputProps,
      label: propsLabel,
      type,
      labelClassName
    } = this.props;

    const inputAttributes = {
      ...inputProps,
      checked: this.props.checked,
      disabled: this.props.disabled,
      id: this.props.id,
      name: this.props.name,
      onChange: this.props.onChange,
      onClick: this.props.onClick,
      'aria-invalid': this.props.validation,
      required: this.props.required,
      type,
      value: this.props.value,
      className: this.props.className
    };

    return (
      <label className={classNames(`control control--${type}`, labelClassName)}>
        <input {...inputAttributes} />
        <div className='control__indicator'></div>
        {propsLabel}
      </label>
    );
  }
}

ControlOption.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  label: PropTypes.node,
  labelClassName: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  required: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.any,
  className: PropTypes.string
};

export default ControlOption;



// WEBPACK FOOTER //
// ./src/containers/components/control-option.js